import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Patch ResizeObserver so its callback runs on the next animation frame. This
// eliminates the benign "ResizeObserver loop completed with undelivered
// notifications" error that Radix Dialog can trigger during rapid open/close.
// Fixing the ROOT CAUSE prevents webpack-dev-server from ever seeing the error
// (its overlay would otherwise intercept clicks in dev mode).
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class WrappedRO extends OriginalRO {
    constructor(cb) {
      // Defer the callback to the next animation frame. Let real callback
      // exceptions propagate (they're logged by the browser) — we only want
      // to fix the benign "loop completed" browser-scheduling issue.
      super((entries, observer) => {
        window.requestAnimationFrame(() => cb(entries, observer));
      });
    }
  };
}

// Belt-and-suspenders: if the webpack-dev-server overlay still manages to
// appear with a ResizeObserver message, remove it so it doesn't block clicks.
if (typeof window !== "undefined") {
  const RO_MSGS = [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
  ];
  const stopIfBenign = (msg) => msg && RO_MSGS.some((m) => msg.includes(m));
  window.addEventListener("error", (e) => {
    if (stopIfBenign(e?.message)) { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);
  window.addEventListener("unhandledrejection", (e) => {
    if (stopIfBenign(e?.reason?.message)) e.preventDefault();
  }, true);
  // Poll and remove the dev overlay iframe if it appears with ResizeObserver text.
  if (typeof MutationObserver !== "undefined") {
    const removeOverlay = () => {
      const overlay = document.getElementById("webpack-dev-server-client-overlay");
      if (!overlay) return;
      try {
        const text = overlay.contentDocument?.body?.innerText || "";
        if (RO_MSGS.some((m) => text.includes(m))) overlay.remove();
      } catch (_) { /* cross-origin, ignore */ }
    };
    new MutationObserver(removeOverlay).observe(document.documentElement, { childList: true, subtree: true });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
